import { makeStyles } from "@material-ui/core";

export const actionBarId = "action-bar";

const useStyles = makeStyles(_ => ({
  actionBar: {
    display: "flex"
  }
}));

export default function ActionBar() {
  const classNames = useStyles();
  return <div id={actionBarId} className={classNames.actionBar} />;
}
